
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../../../redux/library/selector';
import { HiOutlineTrash } from 'react-icons/hi';
import { InputLabelContainer } from '../../../../../../../common/components/form/label/containers/input-label.container';
import { FaCamera, FaFile, FaVideo } from 'react-icons/fa';
import { AccordionContainer } from '../../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../../common/components/form/form.module';

export const DBNEntityAttributesComponents = ({
  changeImage,
  deleteEntityAttribute,
  handleFormItemChange,
  entityAttributeIndex,
  entityAttribute,
}:any) => {
  const libraryData = useSelector(selectListItems)
  return (
    <>
      <AccordionContainer
        child={
          <>
            <div className=" grid md:grid-cols-3 lg:grid-cols-4 gap-4">
              <InputContainer
                label="EntityAttributeName"
                onValueChange={(event: any, newValue: any) => {
                  handleFormItemChange({
                    value: event.target.value,
                    field: 'EntityAttributeName',
                    idx: entityAttributeIndex,
                  });
                }}
                type="text"
                value={entityAttribute?.EntityAttributeName}
              />
              <InputContainer
                label="EntityAttributeType Name"
                labelField="Description"
                list={libraryData?.result?.TenantAttributeValueDataType}
                onValueChange={(event: any, newValue: any) => {
                  handleFormItemChange({
                    value: event.target.value,
                    field: 'EntityAttributeTypeId',
                    idx: entityAttributeIndex,
                  });
                }}
                optionName="Choose EntityAttributeType"
                type="select"
                value={entityAttribute?.EntityAttributeTypeId}
                valueField="Value"
              />
              {entityAttribute?.EntityAttributeTypeId ? (
                <button className="text-red-500 hover:text-red-700" onClick={async () => deleteEntityAttribute(entityAttribute, entityAttributeIndex)}>
                    <HiOutlineTrash className="w-6 h-6" />
                  </button>) :(<></>)}
              <div className="col-span-full">
                {entityAttribute?.EntityAttributeTypeId === 1 && (
                  <AccordionContainer
                    child={
                      <div className=" grid md:grid-cols-3 lg:grid-cols-3 gap-4">
                        <InputContainer
                          label="ValueItem1 Type"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'ValueItem1Type',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.ValueItem1Type}
                        />
                        <InputContainer
                          label="ValueItem1 Value"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'ValueItem1Value',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.ValueItem1Value}
                        />
                        <InputContainer
                          label="ValueItem1 Selected"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event,
                              field: 'ValueItem1IsSelected',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="checkbox"
                          value={entityAttribute?.ValueItem1IsSelected}
                        />
                        <InputContainer
                          label="ValueItem2 Type"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'ValueItem2Type',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.ValueItem2Type}
                        />
                        <InputContainer
                          label="ValueItem2 Value"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'ValueItem2Value',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.ValueItem2Value}
                        />
                        <InputContainer
                          label="ValueItem2 Selected"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event,
                              field: 'ValueItem2IsSelected',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="checkbox"
                          value={entityAttribute?.ValueItem2IsSelected}
                        />
                        <InputContainer
                          label="ValueItem3 Type"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'ValueItem3Type',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.ValueItem3Type}
                        />
                        <InputContainer
                          label="ValueItem3 Value"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'ValueItem3Value',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.ValueItem3Value}
                        />
                        <InputContainer
                          label="ValueItem3 Selected"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event,
                              field: 'ValueItem3IsSelected',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="checkbox"
                          value={entityAttribute?.ValueItem3IsSelected}
                        />

                        <InputContainer
                          label="ValueItem4 Type"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'ValueItem4Type',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.ValueItem4Type}
                        />

                        <InputContainer
                          label="ValueItem4 Value"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'ValueItem4Value',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.ValueItem4Value}
                        />
                        <InputContainer
                          label="ValueItem4 Selected"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event,
                              field: 'ValueItem4IsSelected',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="checkbox"
                          value={entityAttribute?.ValueItem4IsSelected}
                        />
                        <InputContainer
                          label="ValueItem5 Type"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'ValueItem5Type',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.ValueItem5Type}
                        />
                        <InputContainer
                          label="ValueItem5 Value"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'ValueItem5Value',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.ValueItem5Value}
                        />
                        <InputContainer
                          label="ValueItem5 Selected"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event,
                              field: 'ValueItem5IsSelected',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="checkbox"
                          value={entityAttribute?.ValueItem5IsSelected}
                        />
                      </div>
                    }
                    expandedPanel="basicInfo"
                    headerTitle="MultiControl Type"
                  />
                )}
              </div>{' '}
              <div className="col-span-full">
                {entityAttribute?.EntityAttributeTypeId === 2 && (
                  <AccordionContainer
                    child={
                      <div className=" grid md:grid-cols-3 lg:grid-cols-3 gap-4">
                        <InputContainer
                          label="ValueItem1 Type"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'ValueItem1Type',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.ValueItem1Type}
                        />
                        <InputContainer
                          label="ValueItem1 Value"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'ValueItem1Value',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.ValueItem1Value}
                        />
                        <InputContainer
                          label="ValueItem1 Selected"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event,
                              field: 'ValueItem1IsSelected',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="checkbox"
                          value={entityAttribute?.ValueItem1IsSelected}
                        />
                        <InputContainer
                          label="ValueItem2 Type"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'ValueItem2Type',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.ValueItem2Type}
                        />
                        <InputContainer
                          label="ValueItem2 Value"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'ValueItem2Value',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.ValueItem2Value}
                        />
                        <InputContainer
                          label="ValueItem2 Selected"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event,
                              field: 'ValueItem2IsSelected',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="checkbox"
                          value={entityAttribute?.ValueItem2IsSelected}
                        />
                        <InputContainer
                          label="ValueItem3 Type"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'ValueItem3Type',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.ValueItem3Type}
                        />
                        <InputContainer
                          label="ValueItem3 Value"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'ValueItem3Value',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.ValueItem3Value}
                        />
                        <InputContainer
                          label="ValueItem3 Selected"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event,
                              field: 'ValueItem3IsSelected',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="checkbox"
                          value={entityAttribute?.ValueItem3IsSelected}
                        />
                        <InputContainer
                          label="ValueItem4 Type"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'ValueItem4Type',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.ValueItem4Type}
                        />
                        <InputContainer
                          label="ValueItem4 Value"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'ValueItem4Value',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.ValueItem4Value}
                        />
                        <InputContainer
                          label="ValueItem4 Selected"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event,
                              field: 'ValueItem4IsSelected',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="checkbox"
                          value={entityAttribute?.ValueItem4IsSelected}
                        />
                        <InputContainer
                          label="ValueItem5 Type"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'ValueItem5Type',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.ValueItem5Type}
                        />
                        <InputContainer
                          label="ValueItem5 Value"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'ValueItem5Value',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.ValueItem5Value}
                        />
                        <InputContainer
                          label="ValueItem5 Selected"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event,
                              field: 'ValueItem5IsSelected',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="checkbox"
                          value={entityAttribute?.ValueItem5IsSelected}
                        />
                      </div>
                    }
                    expandedPanel="basicInfo"
                    headerTitle="MultiControl Type"
                  />
                )}
              </div>{' '}
              <div className="col-span-full">
                {entityAttribute?.EntityAttributeTypeId === 3 && (
                  <AccordionContainer
                    child={
                      <div className=" grid md:grid-cols-3 lg:grid-cols-3 gap-4">
                      <InputContainer
                       label="Value"
                       onValueChange={(event: any, newValue: any) => {
                         handleFormItemChange({
                           value: event,
                           field: 'TextValue',
                           idx: entityAttributeIndex,
                         });
                       }}
                       type="checkbox"
                       value={entityAttribute?.TextValue}
                     />
                      </div>
                    }
                    expandedPanel="basicInfo"
                    headerTitle="SingleControl Type"
                  />
                )}
              </div>{' '}
              <div className="col-span-full">
                {entityAttribute?.EntityAttributeTypeId === 50 && (
                  <AccordionContainer
                    child={
                      <div className=" grid md:grid-cols-3 lg:grid-cols-3 gap-4">
                      <InputContainer
                       label="Value"
                       onValueChange={(event: any, newValue: any) => {
                         handleFormItemChange({
                           value: event,
                           field: 'TextValue',
                           idx: entityAttributeIndex,
                         });
                       }}
                       type="checkbox"
                       value={entityAttribute?.TextValue}
                       isDisabled
                     />
                      </div>
                    }
                    expandedPanel="basicInfo"
                    headerTitle="MultiControl Type"
                  />
                )}
              </div>{' '}
              <div className="col-span-full">
                {entityAttribute?.EntityAttributeTypeId === 4 && (
                  <AccordionContainer
                    child={
                      <div className=" grid md:grid-cols-3 lg:grid-cols-4 gap-4">
                        <InputContainer
                          label="TextValue"
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'TextValue',
                              idx: entityAttributeIndex,
                            });
                          }}
                          type="text"
                          value={entityAttribute?.TextValue}
                        />
                      </div>
                    }
                    expandedPanel="basicInfo"
                    headerTitle="SingleControl Type"
                  />
                )}
              </div>{' '}
              <div className="col-span-full">
                {entityAttribute?.EntityAttributeTypeId === 10 && (
                  <AccordionContainer
                    child={
                      <div className=" grid md:grid-cols-3 lg:grid-cols-4 gap-4">
                        <textarea
 
                        value={entityAttribute?.TextValue}
                        onChange={(event: any) => {
                          handleFormItemChange({
                            value: event.target.value,
                            field: 'TextValue',
                            idx: entityAttributeIndex,
                          });
                        }}
                        rows={4} 
                        cols={100} 
                        />
                      </div>
                    }
                    expandedPanel="basicInfo"
                    headerTitle="SingleControl Type"
                  />
                )}
              </div>{' '}
              <div className="col-span-full">
                {entityAttribute?.EntityAttributeTypeId === 20 && (
                  <AccordionContainer
                    child={
                      <InputContainer
                        label="Date Value"
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange({
                            value: event.target.value,
                            field: 'DateValue',
                            idx: entityAttributeIndex,
                          });
                        }}
                        type="date"
                        value={entityAttribute?.DateValue}
                      />
                    }
                    expandedPanel="basicInfo"
                    headerTitle="SingleControl Type"
                  />
                )}
              </div>{' '}
              <div className="col-span-full">
                {entityAttribute?.EntityAttributeTypeId === 30 && (
                  <AccordionContainer
                    child={
                      <div className=" grid md:grid-cols-3 lg:grid-cols-4 gap-4">
                         <InputContainer
                          label="File Type"
                          labelField="Text"
                          list={libraryData?.result?.FileType}
                          onValueChange={(event: any, newValue: any) => {
                            handleFormItemChange({
                              value: event.target.value,
                              field: 'FileTypeId',
                              idx: entityAttributeIndex,
                            });
                          }}
                          optionName="Choose FileType"
                          type="select"
                          value={entityAttribute?.FileTypeId}
                          valueField="Value"
                        />

{entityAttribute.FileTypeId === 10 &&
                    <div  onClick={() => changeImage(
                      entityAttributeIndex,
                      'FileMappingURL',
                      'image'
                    )}> 
                       <InputLabelContainer label="Pictures"/>
                      {entityAttribute?.FileMappingURL && <img

                        src={entityAttribute?.FileMappingURL}
                        className="w-12 h-12" />
}
                      
                        <FaCamera  className=' text-2xl text-skin-ouprimary'/>
                   </div>
}
                  {entityAttribute.FileTypeId === 30 &&

<div  onClick={() => changeImage(
  entityAttributeIndex,
  'FileMappingURL',
  'video'
)}> 
   <InputLabelContainer label="Videos"/>
  {entityAttribute?.FileMappingURL && <video

    src={entityAttribute?.FileMappingURL}
    className="w-12 h-12" />
}
  
    <FaVideo className=' text-2xl text-skin-ouprimary'/>
</div>
}
                      
                  {entityAttribute.FileTypeId === 20 &&
                    
                      <div onClick={() => changeImage(
                        entityAttributeIndex,
                        'FileMappingURL',
                        'document'
                      )}><label className="text-[#4E6796] text-xs font-medium mb-2 block">Documents</label><strong>{entityAttribute?.FileMappingURL}</strong>
                     
                     <FaFile className=' text-2xl text-skin-ouprimary'/>
                         </div>

                   }

                      </div>
                    }                    
                    
                    expandedPanel="basicInfo"
                    headerTitle="SingleControl Type"
                  />
                )}
              </div>{' '}
              <div className="col-span-full">
                {entityAttribute?.EntityAttributeTypeId === 40 && (
                  <AccordionContainer
                    child={
                      <div className=" grid md:grid-cols-3 lg:grid-cols-4 gap-4">
                        <input 
                    type="color" 
                    style={{ height: '40px', width: '200px' }}
                    value={entityAttribute?.TextValue}
                    onChange={(event: any) => {
                      handleFormItemChange({
                        value: event.target.value,
                        field: 'TextValue',
                        idx: entityAttributeIndex,
                      });
                        }}/>
                      </div>
                    }
                    expandedPanel="basicInfo"
                    headerTitle="SingleControl Type"
                  />
                )}
              </div>
            </div>
          </>
        }
        expandedPanel="basicInfo"
        headerTitle="Entity Attribute Info"
      />
    </>
  );
};
